import { render, staticRenderFns } from "./MicrocartBanners.vue?vue&type=template&id=8052a1d8"
import script from "./MicrocartBanners.vue?vue&type=script&lang=js"
export * from "./MicrocartBanners.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports